// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"0111014c","787":"2e3ea8f7"}[chunkId] + ".chunk.js";
};